import { render } from "./OnlyLabelAndValue.vue?vue&type=template&id=a706aa2a"
import script from "./OnlyLabelAndValue.vue?vue&type=script&lang=js"
export * from "./OnlyLabelAndValue.vue?vue&type=script&lang=js"
script.render = render

export default script